import { Colors, UiKitColorKeys } from '@surglogs-app/ui.theme'

import { ColorVariant } from './VariantService'
export { ColorVariants as TypographyColorVariants } from './VariantService'
export type TypographyColorVariant = Colors | ColorVariant

const VariantKeyValues: Record<ColorVariant, Colors> = {
  default: 'navy.100',
  danger: 'red.100',
  success: 'green.100',
  warning: 'orange.100',
  primary: 'blue.100',
  secondary: 'white.100',
}

const isThemeColorKey = (key: string): key is Colors => {
  return UiKitColorKeys.includes(key)
}

export const getColorKeyFromColorVariant = (
  variant: TypographyColorVariant,
): Colors => {
  if (!isThemeColorKey(variant)) {
    return VariantKeyValues[variant]
  }

  return variant
}
